<template>
  <div>
    <resumo :resumo="resumo" :permission="permission" />
    <listagem
      :search="search"
      :headers="headers.filter((item) => item.display !== false)"
      :data="data"
      :dataTotal="dataTotal"
      :tela="permission"
      :pageSize="page_size"
      :extra_params="extra_params"
      @handleGet="handleGet"
      @cleanData="data = []"
      @getDownload="download"
      :canDownload="canDownload"
      @loading="$emit('loading')"
      @loaded="$emit('loaded')"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Listagem from '../listagem/Componente.vue'
import Resumo from '../Resumo.vue'
import { BasicPermissions, Sequences } from '@/utils/permissions'
import { getUrl, downloadUrl } from '@/utils/index'

export default {
  name: 'Geral',
  props: {
    search: {
      type: String,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
    tela: {
      type: String,
      required: true,
    },
  },
  components: {
    Listagem,
    Resumo,
  },
  data() {
    return {
      page_size: 15,
      data: [],
      dataTotal: 0,
      resumo: undefined,
      options: {},
      extra_params: {
        tempo_medio: false,
      },
    }
  },
  computed: {
    ...mapState('auth', ['empresaAtual', 'user']),
    ...mapState('gerenciamentoServico', ['params']),
    ...mapState('patio', ['regioes', 'representantes']),

    permission() {
      return Sequences.GerenciamentoServico.toString()
    },

    canList() {
      return this.$canDo(BasicPermissions.VISUALIZAR, this.permission)
    },
    canCreate() {
      return this.$canDo(BasicPermissions.CADASTRAR, this.permission)
    },
    canUpdate() {
      return this.$canDo(BasicPermissions.EDITAR, this.permission)
    },
    canDelete() {
      return this.$canDo(BasicPermissions.EXCLUIR, this.permission)
    },
    canDownload() {
      return Object.keys(this.params).length > 0
    },
  },
  methods: {
    ...mapActions('patio', [
      'getAllAgendamentosByParams',
      'getAgendamentoListagem',
      'getRegioesColaborator',
    ]),
    ...mapActions('template', ['errorMessage']),
    handleGet(event) {
      this.options = event
      this.page_size = event.itemsPerPage
      this.handleGetAgendamentos(event.page)
    },
    async download() {
      await this.getDownload()
    },
    async getDownload() {
      console.log(
        'getDownload from patio/GerenciamentoServico/geral/Componente.vue'
      )
      if (!this.canDownload) return
      if (
        this.empresaAtual.representantes.length > 0 &&
        this.params.regiao == undefined
      ) {
        await this.getRegioesColaborator()

        if (this.regioes.length > 0) {
          this.params.regiao = this.regioes.map((regiao) => regiao.public_id)
          this.params.representante = this.user.public_id
        }
      }
      this.$emit('loading')
      let data = []
      try {
        const indicadores = this.headers
          .filter((item) => item.value != 'actions')
          .map((item) => item.text)
          .join(',')
        const path = 'api/v1/relatorios/agendamentos/download/'
        const params = {
          proprietario: this.empresaAtual.public_id,
          ...this.params,
          indicadores,
        }
        const url = getUrl(path, params)
        await downloadUrl(url)
      } catch (error) {
        console.log(error)
        this.errorMessage(
          'Não foi possível baixar a planilha. Tente novamente mais tarde.'
        )
      } finally {
        this.$emit('loaded')
      }
      return data
    },

    async handleGetAgendamentos(page = 1, new_page_size = undefined) {
      if (new_page_size) {
        this.page_size = new_page_size
      }
      const page_size = this.page_size
      if (!Object.keys(this.params).length) return

      this.$emit('loading')

      if (
        this.empresaAtual.representantes.length > 0 &&
        this.params.regiao == undefined
      ) {
        await this.getRegioesColaborator()

        if (this.regioes.length > 0) {
          this.params.regiao = this.regioes.map((regiao) => regiao.public_id)
          this.params.representante = this.user.public_id
        }
      }

      if (this.empresaAtual.grupo.sub_produtos.length > 0) {
        this.params.sub_produto = this.empresaAtual.grupo.sub_produtos.join(',')
      }

      try {
        const { sortBy, sortDesc } = this.options

        let ordering
        if (
          sortBy &&
          sortBy.length === 1 &&
          sortDesc &&
          sortDesc.length === 1
        ) {
          ordering = sortBy[0]
          ordering = sortDesc[0] ? '-' + ordering : ordering
          ordering = ordering.replaceAll('.', '__')
        }
        const { results, count, resumo } = await this.getAgendamentoListagem({
          page,
          page_size: (page_size === -1 && this.dataTotal) || page_size,
          ordering,
          proprietario: this.empresaAtual.public_id,
          ...this.params,
          ...this.extra_params,
        })

        this.resumo = resumo
        this.data = results
        this.dataTotal = count
      } catch (e) {
        if (e.response.status === 404) {
          this.errorMessage('Página não encontrada')
        } else {
          this.errorMessage(
            'Erro ao carregar agendamentos. Por favor atualize a página!'
          )
        }
      } finally {
        this.$emit('loaded')
      }
    },
  },
}
</script>
